// extracted by mini-css-extract-plugin
export var borderRadius = "_fn-4";
export var large = "_fn-3";
export var logoContainer = "_fn-0";
export var nameLogo = "_fn-2";
export var small = "_fn-1";